import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
  size?: 'md' | 'lg';
  className?: string;
}
export function Button({
  children,
  onClick,
  variant = 'primary',
  size = 'md',
  className = ''
}: ButtonProps) {
  const baseStyles = 'font-body font-semibold rounded-lg transition-all duration-300 inline-block text-center';
  const variantStyles = {
    primary: 'bg-terracotta text-white hover:bg-opacity-90 shadow-lg hover:shadow-xl',
    secondary: 'bg-wheat text-brown hover:bg-opacity-90 shadow-md hover:shadow-lg'
  };
  const sizeStyles = {
    md: 'px-8 py-3 text-base',
    lg: 'px-10 py-4 text-lg'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`} data-id="element-1">
      {children}
    </motion.button>;
}